var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#194a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "195b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#195b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E61D00",
    fillRule: "evenodd",
    d: "M0 10.668h22v5.333H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A9B00",
    fillRule: "evenodd",
    d: "M0 0h22v5.333H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD900",
    fillRule: "evenodd",
    d: "M11 7.465c.289 0 .524-.239.524-.533A.53.53 0 0 0 11 6.398a.53.53 0 0 0-.524.534c0 .294.235.533.524.533m2.095 0c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235.533.524.533m2.095 0c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.523.534c0 .294.234.533.523.533",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009432",
    fillRule: "evenodd",
    d: "M12.048 8.532c.289 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534m2.095 0c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A46620",
    fillRule: "evenodd",
    d: "M12.571 7.465h1.048v2.133H12.57z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0071D1",
    fillRule: "evenodd",
    d: "M0 0v16.035L7.333 8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "194a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagGq = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagGq);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";